import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get } from 'lodash';
import React from 'react';
import { Form } from 'src/components/Antd';
import { ProductsInShoppingCartTable } from 'src/constrains/AdvancedFilters/Components';
import { EInclude } from 'src/constrains/AdvancedFilters/Components/CommonStoreProductsWithTable';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { IntClear } from '../Components';
const Item = Form.Item;

const _ProductsInShoppingCartTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { root, form, radioName, listName, disabled, state, ...rest } = props;
  const onClear = () => {
    form.setFieldsValue(state);
  };
  return (
    <SectionWrapper
      title={getI18n(
        'customerTag.productsInShoppingCart.productintheshoppingcart',
      )}>
      <ItemWrapper title=''>
        <ProductsInShoppingCartTable
          disabled={disabled}
          radioName={radioName}
          listName={listName}
          //   onReselect={handleOnReselect}
          id={'CustomerTagProductsInShoppingCartTable'}
          onClear={onClear}
          {...rest}
        />
        <Item
          shouldUpdate={(p, c) => {
            const pv = get(p, radioName);
            const cv = get(c, radioName);
            return cv !== pv;
          }}>
          {({ getFieldValue }) => {
            const v = getFieldValue(radioName);
            if (v === EInclude.INCLUDE_ANY) {
              return (
                <IntClear
                  disabled={disabled}
                  form={form}
                  root={root}
                  value={radioName}
                  state={state}
                />
              );
            }
          }}
        </Item>
      </ItemWrapper>
    </SectionWrapper>
  );
};
export default _ProductsInShoppingCartTable;
